// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General ----------------------------------------------------------------------------------------- */

.form_formContainer__Ts9fx { 
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  position: relative;           /* ✅ não usa mais absolute */
  margin: 30px auto;            /* ✅ centraliza no meio */
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 30px;
  box-sizing: border-box;
  width: 100%;                  /* ✅ ocupa toda a largura disponível */
  max-width: 600px;             /* ✅ limita no desktop */
  color: #303030;
  accent-color: #303030;
  word-break: break-word;       /* ✅ evita que textos longos estourem */
}

.form_logoContainer__y3QrD {
  width: 100%;
  display: flex;
  justify-content: center;
}

.form_formTitle__1uYOK {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}

.form_formGroup__AenQr {
  margin: 0;
  display: flex;
  flex-direction: column;
}

.form_formLabel__RVZ6d {
  font-size: 16px;
  margin: 0 0 6px 12px;
}

.form_formControl__WdtqV {
  resize: none;
  width: 100%;
  border: 1px #303030  solid;
  box-sizing: border-box;
  padding: 8px;
  font-size: 15px;
  border-radius: 3px;
}

.form_checkbox__ophRf {
  margin: 0 0 0 8px;
}

.form_checkbox__ophRf >input {
  margin: 0 8px 0 0;
  text-align: center;
}

.form_checkbox__ophRf > label {
  vertical-align: middle;
  font-size: 14px;
  font-weight: 100;
}

.form_rate__2njao * {
  appearance: none;
}

.form_rate__2njao {
  display: flex;
  padding: 10px;
  margin: 0 0 0 8px;
}

.form_rate__2njao > input {
  margin: 0 8px 0 0;
  text-align: center;
}

.form_rate__2njao > label {
  margin-left: 10%;
  vertical-align: middle;
  font-size: 30px;
  font-weight: 100;
}

.form_rate_checked__IIIlA * {
  appearance: none;
}

.form_rate_checked__IIIlA {
  display: flex;
  padding: 10px;
  border-radius: 10px;
  background-color: #c2c2c2;
  margin: 0 0 0 8px;
}

.form_rate_checked__IIIlA > input {
  margin: 0 8px 0 0;
  text-align: center;
}

.form_rate_checked__IIIlA > label {
  vertical-align: middle;
  margin-left: 10%;
  font-size: 30px;
  font-weight: 100;
}

.form_rate_label__qXU8P {
  vertical-align: middle;
  width: 100%;
}

.form_rate_label_big__dyVjF {
  font-size: 30px;
}

.form_radioGroup__pP3tJ {
  padding: 5px 0 0 0;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: nowrap;
}

.form_submit__UWXyT {
  width: 100%;
  border: 1px #303030 solid;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 8px;
  font-size: 15px;
  font-weight: bold;
  background-color: #353535;
  color: #ffffff;
  cursor: pointer;
}

.form_submit__UWXyT:hover {
  border: 1px #222222 solid;
  background-color: #272727;
}

.form_submit__UWXyT:active {
  border: 1px #202020 solid;
  background-color: #222222;
}

.form_warning__2zxG\\+ {
  font-size: 17px;
  color: #f03e3e;
}

@media only screen and (max-width: 600px) {
  .form_formContainer__Ts9fx { 
    width: 100%; 
    /* height: 100%; */
    padding: 70px 30px 30px 30px;
    margin: 0;
    border-radius: 0;
  }
}
/* General ----------------------------------------------------------------------------------------- */`, "",{"version":3,"sources":["webpack://./src/styles/research/form.module.css"],"names":[],"mappings":"AAAA,sGAAsG;;AAEtG;EACE,sEAAsE;EACtE,kBAAkB,YAAY,4BAA4B;EAC1D,iBAAiB,aAAa,yBAAyB;EACvD,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,WAAW,mBAAmB,sCAAsC;EACpE,gBAAgB,cAAc,wBAAwB;EACtD,cAAc;EACd,qBAAqB;EACrB,sBAAsB,QAAQ,uCAAuC;AACvE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;IACT,gBAAgB;EAClB;AACF;AACA,sGAAsG","sourcesContent":["/* General ----------------------------------------------------------------------------------------- */\n\n.formContainer { \n  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;\n  position: relative;           /* ✅ não usa mais absolute */\n  margin: 30px auto;            /* ✅ centraliza no meio */\n  padding: 30px;\n  border-radius: 20px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  box-sizing: border-box;\n  width: 100%;                  /* ✅ ocupa toda a largura disponível */\n  max-width: 600px;             /* ✅ limita no desktop */\n  color: #303030;\n  accent-color: #303030;\n  word-break: break-word;       /* ✅ evita que textos longos estourem */\n}\n\n.logoContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.formTitle {\n  text-align: center;\n  font-weight: bold;\n  font-size: 30px;\n}\n\n.formGroup {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.formLabel {\n  font-size: 16px;\n  margin: 0 0 6px 12px;\n}\n\n.formControl {\n  resize: none;\n  width: 100%;\n  border: 1px #303030  solid;\n  box-sizing: border-box;\n  padding: 8px;\n  font-size: 15px;\n  border-radius: 3px;\n}\n\n.checkbox {\n  margin: 0 0 0 8px;\n}\n\n.checkbox >input {\n  margin: 0 8px 0 0;\n  text-align: center;\n}\n\n.checkbox > label {\n  vertical-align: middle;\n  font-size: 14px;\n  font-weight: 100;\n}\n\n.rate * {\n  appearance: none;\n}\n\n.rate {\n  display: flex;\n  padding: 10px;\n  margin: 0 0 0 8px;\n}\n\n.rate > input {\n  margin: 0 8px 0 0;\n  text-align: center;\n}\n\n.rate > label {\n  margin-left: 10%;\n  vertical-align: middle;\n  font-size: 30px;\n  font-weight: 100;\n}\n\n.rate_checked * {\n  appearance: none;\n}\n\n.rate_checked {\n  display: flex;\n  padding: 10px;\n  border-radius: 10px;\n  background-color: #c2c2c2;\n  margin: 0 0 0 8px;\n}\n\n.rate_checked > input {\n  margin: 0 8px 0 0;\n  text-align: center;\n}\n\n.rate_checked > label {\n  vertical-align: middle;\n  margin-left: 10%;\n  font-size: 30px;\n  font-weight: 100;\n}\n\n.rate_label {\n  vertical-align: middle;\n  width: 100%;\n}\n\n.rate_label_big {\n  font-size: 30px;\n}\n\n.radioGroup {\n  padding: 5px 0 0 0;\n  display: flex;\n  justify-content: space-evenly;\n  flex-wrap: nowrap;\n}\n\n.submit {\n  width: 100%;\n  border: 1px #303030 solid;\n  border-radius: 3px;\n  box-sizing: border-box;\n  padding: 8px;\n  font-size: 15px;\n  font-weight: bold;\n  background-color: #353535;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.submit:hover {\n  border: 1px #222222 solid;\n  background-color: #272727;\n}\n\n.submit:active {\n  border: 1px #202020 solid;\n  background-color: #222222;\n}\n\n.warning {\n  font-size: 17px;\n  color: #f03e3e;\n}\n\n@media only screen and (max-width: 600px) {\n  .formContainer { \n    width: 100%; \n    /* height: 100%; */\n    padding: 70px 30px 30px 30px;\n    margin: 0;\n    border-radius: 0;\n  }\n}\n/* General ----------------------------------------------------------------------------------------- */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `form_formContainer__Ts9fx`,
	"logoContainer": `form_logoContainer__y3QrD`,
	"formTitle": `form_formTitle__1uYOK`,
	"formGroup": `form_formGroup__AenQr`,
	"formLabel": `form_formLabel__RVZ6d`,
	"formControl": `form_formControl__WdtqV`,
	"checkbox": `form_checkbox__ophRf`,
	"rate": `form_rate__2njao`,
	"rate_checked": `form_rate_checked__IIIlA`,
	"rate_label": `form_rate_label__qXU8P`,
	"rate_label_big": `form_rate_label_big__dyVjF`,
	"radioGroup": `form_radioGroup__pP3tJ`,
	"submit": `form_submit__UWXyT`,
	"warning": `form_warning__2zxG+`
};
export default ___CSS_LOADER_EXPORT___;
